module.exports = __webpack_public_path__ + "static/media/Home_02.029d0d4f.png";